$(document).ready(function () {
  //Menu hover
  $(".nav-ul>li").hover(
    function () {
      $(this)
        .children(".super-menu")
        .css("left", `-${$(this).offset().left}px`);
      $(this)
        .children(".secondary-menu-ul")
        .addClass("animate__fadeInUp")
        .removeClass("animate__fadeOutDown")
        .show();
    },
    function () {
      $(this)
        .children(".secondary-menu-ul")
        .addClass("animate__fadeOutDown")
        .removeClass("animate__fadeInUp")
        .fadeOut(500);

    }
  );

  //Super-Menu Click
  $(".super-menu-left>p").click(function () {
    $(this).addClass("super-menu-active");
    $(this).siblings("p").removeClass("super-menu-active");

    const index = $(this).index();

    $(this)
      .parent()
      .siblings(".super-menu-right")
      .children(".super-menu-product")
      .css("display", "none");

    setTimeout(() => {
      $(this)
        .parent()
        .siblings(".super-menu-right")
        .children(".super-menu-product")
        .eq(index)
        .css("display", "inline-block");
    }, 0);
  });

  //Super-Menu Listening
  // const myOffcanvas = $("#h5-menu");
  // myOffcanvas.on("show.bs.offcanvas", (event) => {
  //   $("body").css({ position: "fixed", width: "100vw" }).animate(
  //     {
  //       left: "75%",
  //     },
  //     300
  //   );
  //   $("#menu-switch").removeClass("bi-list");
  //   $("#menu-switch").addClass("bi-x");
  // });
  // myOffcanvas.on("hide.bs.offcanvas", (event) => {
  //   $("body").animate(
  //     {
  //       left: "0",
  //     },
  //     300
  //   );
  //   setTimeout(() => {
  //     $("body").removeAttr("style");
  //   }, 300);
  //
  //   $("#menu-switch").addClass("bi-list");
  //   $("#menu-switch").removeClass("bi-x");
  // });

  const myCollapsible = $(".accordion-collapse");
  myCollapsible.on("show.bs.collapse", (event) => {
    $(`i[aria-controls='${event.target.id}']`).removeClass("bi-plus-lg");
    $(`i[aria-controls='${event.target.id}']`).addClass("bi-dash-lg");
  });

  myCollapsible.on("hide.bs.collapse", (event) => {
    $(`i[aria-controls='${event.target.id}']`).addClass("bi-plus-lg");
    $(`i[aria-controls='${event.target.id}']`).removeClass("bi-dash-lg");
  });

  $(".sales-promotion-placeholder").css(
    "height",
    $(".sales-promotion").innerHeight()
  );

  setTimeout(() => {
    $(".nav-placeholder").css("height", $(".nav-fixed").outerHeight(true));
  }, 300);

  $(window).resize(function () {
    setTimeout(() => {
      $(".nav-placeholder").css("height", $(".nav-fixed").outerHeight(true));
    }, 300);
  });
  window.addEventListener(
    "scroll",
    throttle(() => {
      let scrollTop =
        document.body.scrollTop || document.documentElement.scrollTop;
      if (scrollTop > $("header").innerHeight()) {
        $(".nav-fixed")
          .css({
            position: "fixed",
            top: $(".sales-promotion").innerHeight(),
          })
          .addClass("animate__fadeInDown");
      } else {
        $(".nav-fixed")
          .css({
            position: "unset",
            top: 0,
          })
          .removeClass("animate__fadeInDown");
      }
            if (scrollTop > window.outerHeight) {
          $(".bottom-toolbar-top").show();
        } else {
          $(".bottom-toolbar-top").hide();
        }
    }, 300),
    false
  );
  $(".bottom-toolbar-top").click(function () {
    $("html").animate({ scrollTop: 0 }, 0);
    return false;
  });

  function throttle(fn, delay) {
    let timer;

    return function () {
      if (!timer) {
        timer = setTimeout(() => {
          fn();
          clearTimeout(timer);
          timer = null;
        }, delay);
      }
    };
  }
  $(".header-login").on("click", function (e) {
    $(this)
      .children("div")
      .addClass("animate__fadeInUp")
      .removeClass("animate__fadeOutDown")
      .show();

    $(document).one("click", function () {
      $(".header-login ")
        .children("div")
        .addClass("animate__fadeOutDown")
        .removeClass("animate__fadeInUp");
      setTimeout(() => {
        $(".header-login ").children("div").hide();
      }, 500);
    });

    e.stopPropagation();
  });

  $(".header-login > div").on("click", function (e) {
    e.stopPropagation();
  });

  /* 2022-12-27 start */
  $(".national-switch,.national-switch-h5").click(function () {
    if (!$(this).data("show")) {
      $(this).children("a").css("display", "inline-flex");
      $(this).data("show", 1);
    } else {
      $(this).children("a").css("display", "none");
      $(this).data("show", 0);
    }
  });

  $(".sales-promotion > .bi").click(function () {
    $(this).parent("div").parent("div").remove();

    $(".nav-fixed").css({
      top: 0,
    });
  });
  /* 2022-12-27 end */
});
